import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { BusinessType } from '../services/businessTypeService';

interface BusinessTypeMultiSelectProps {
  value: number[];
  onChange: (value: number[]) => void;
  options: BusinessType[];
  error?: boolean;
  helperText?: string;
  label?: string;
}

const BusinessTypeMultiSelect: React.FC<BusinessTypeMultiSelectProps> = ({
  value,
  onChange,
  options,
  error,
  helperText,
  label = 'Business Types',
}) => {
  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option.name}
      value={options.filter((bt) => value.includes(bt.id))}
      onChange={(_, newValue) => onChange(newValue.map((bt) => bt.id))}
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default BusinessTypeMultiSelect; 